// extracted by mini-css-extract-plugin
export var border = "_bs-b";
export var circle = "_bs-3";
export var circleInner = "_bs-5";
export var disabled = "_bs-1";
export var focused = "_bs-a";
export var md = "_bs-8";
export var radioButton = "_bs-0";
export var radioInput = "_bs-2";
export var selected = "_bs-9";
export var sm = "_bs-7";
export var text = "_bs-4";
export var xs = "_bs-6";